import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';
import './article-local-store-availability-dialog.scss';
import register from 'ShopUi/app/registry';

export default register('product-local-store-availability', () => importWithFallback(() => import('./product-local-store-availability-dialog')));
